import React from 'react';

import Admin from '@Pages/Admin';
import { addRouteNamespace } from '@Utils/actions';
import ArcGisOauthCallback from '../integrations/arcgis/ArcGisSettings/pages/ArcGisOauthCallback.page';

export const integrationPages = (page: number) =>
	[
		{
			title: 'Integrations',
			to: addRouteNamespace('integrations/:integrationPageName/:editId?'),
			render: <Admin page={page} />,
		},
		{
			title: 'ESRI integration',
			to: addRouteNamespace('oauth/esri'),
			render: <ArcGisOauthCallback />,
		},
	] as {
		title: string;
		to: string;
		render: JSX.Element;
	}[];
